// Makester, theme runtime
// State: saved (localStorage), recent searches (localStorage), cart (Shopify /cart.js).
// Controllers: label modal, bag drawer, progress banner, live search suggestions, hearts.

(function () {
  'use strict';

  const LS = {
    get(key, fallback) {
      try { return JSON.parse(localStorage.getItem(key)) ?? fallback; }
      catch { return fallback; }
    },
    set(key, val) { localStorage.setItem(key, JSON.stringify(val)); },
  };
  // Cart touched THIS tab session (Ed, 2026-09-03). The cart page shows a
  // "Saved from your last visit" line with a Clear button only when nothing
  // has been added or changed in this session — two buyers on 2 Sep landed
  // on a basket carried over from the day before and one spent 90 seconds
  // fighting it. sessionStorage dies with the tab, which is what "visit"
  // means here.
  const touchCart = () => { try { sessionStorage.setItem('mkCartTouched', '1'); } catch (_) {} };

  const MK = window.MK = {
    saved:  LS.get('mk_saved',  []),
    recent: LS.get('mk_recent', []),
    cart: null,
    productCache: {},

    isSaved(h) { return this.saved.includes(h); },
    toggleSaved(h) {
      const i = this.saved.indexOf(h);
      if (i >= 0) this.saved.splice(i, 1); else this.saved.push(h);
      LS.set('mk_saved', this.saved);
      emit('mk:saved', h);
    },

    pushRecent(q) {
      q = (q || '').trim();
      if (!q) return;
      this.recent = [q, ...this.recent.filter(x => x.toLowerCase() !== q.toLowerCase())].slice(0, 8);
      LS.set('mk_recent', this.recent);
      emit('mk:recent');
    },
    clearRecent() { this.recent = []; LS.set('mk_recent', []); emit('mk:recent'); },

    async refreshCart() {
      try {
        const r = await fetch('/cart.js', { credentials: 'same-origin' });
        this.cart = await r.json();
        emit('mk:cart');
        return this.cart;
      } catch { return null; }
    },
    async addToCart(id, quantity = 1) {
      const r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id, quantity }),
      });
      if (!r.ok) throw new Error(await r.text());
      touchCart();
      await this.refreshCart();
      emit('mk:added');
    },
    async setLineQty(key, quantity) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity }),
      });
      touchCart();
      await this.refreshCart();
    },
    removeLine(key) { return this.setLineQty(key, 0); },

    async fetchProduct(handle) {
      if (this.productCache[handle]) return this.productCache[handle];
      const r = await fetch(`/products/${handle}.js`);
      const p = await r.json();
      this.productCache[handle] = p;
      return p;
    },
  };

  const emit = (name, detail) => document.dispatchEvent(new CustomEvent(name, { detail }));
  const $  = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));

  const money = (pence) => {
    const gbp = (pence / 100).toFixed(2);
    return '£' + gbp.replace(/\.00$/, '.00');
  };

  // ── Hearts on cards ───────────────────────────────────────────────
  function paintHeart(el) {
    const handle = el.dataset.handle;
    el.setAttribute('aria-pressed', MK.isSaved(handle) ? 'true' : 'false');
    el.innerHTML = MK.isSaved(handle) ? '&#9829;' : '&#9825;';
  }
  function bindHearts() {
    $$('.mk-card__heart').forEach(paintHeart);
  }
  document.addEventListener('click', (e) => {
    const h = e.target.closest('.mk-card__heart');
    if (!h) return;
    e.preventDefault();
    e.stopPropagation();
    MK.toggleSaved(h.dataset.handle);
  });
  document.addEventListener('mk:saved', () => {
    $$('.mk-card__heart').forEach(paintHeart);
  });

  // ── Card quick-add — the sitewide card behaviour (Ed, 2026-08-06) ──
  // The peek modal is retired: cards are plain links to the PDP; the corner +
  // is a one-tap add that STAYS on the page (Ed, 2026-08-06: browsing is the
  // behaviour to protect — "people kept searching to fill up"). Feedback is
  // the button flipping to a tick, the header bag count, and a quiet toast
  // offering — never forcing — the way back to the gift list. The PDP's big
  // Add to Basket still lands on the cart: that's the commitment moment.
  const TICK_SVG = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12l5 5L20 7"/></svg>';
  let qtoastTimer = null;
  function quickAddToast() {
    // "Added to cart" (Ed, 2026-08-07): the conventional phrase IS the
    // iconography here — it's the wording every shopper pattern-matches
    // without reading. The count experiment ("3 of 4") read as a puzzle.
    let t = $('.mk-qtoast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'mk-qtoast';
      t.innerHTML = `<span class="mk-qtoast__msg">${TICK_SVG} Added to cart</span><a class="mk-qtoast__link" href="/cart">View &rarr;</a>`;
      document.body.appendChild(t);
    }
    t.classList.remove('is-out');
    clearTimeout(qtoastTimer);
    qtoastTimer = setTimeout(() => t.classList.add('is-out'), 4000);
  }
  function markAdded(el) {
    el.classList.add('is-added');
    el.innerHTML = TICK_SVG;
    el.setAttribute('aria-label', 'In your gift list');
  }
  // Cards render server-side without cart knowledge — paint ticks from the
  // cart on load and after every add, so in-list candles read as in-list.
  function paintQuickAdds() {
    const inCart = new Set(((MK.cart && MK.cart.items) || []).map(it => String(it.variant_id || it.id)));
    $$('[data-mk-quickadd]').forEach(el => {
      if (inCart.has(String(el.dataset.variant))) { if (!el.classList.contains('is-added')) markAdded(el); }
    });
  }
  document.addEventListener('mk:cart', paintQuickAdds);
  async function quickAdd(el) {
    const v = Number(el.dataset.variant);
    if (!v) return;
    if (el.dataset.busy || el.classList.contains('is-added')) return;
    el.dataset.busy = '1';
    el.classList.add('is-busy');
    try {
      await MK.addToCart(v, 1);
      markAdded(el);
      quickAddToast();
    } catch {} finally {
      delete el.dataset.busy;
      el.classList.remove('is-busy');
    }
  }
  document.addEventListener('click', (e) => {
    const qa = e.target.closest('[data-mk-quickadd]');
    if (!qa) return;
    e.preventDefault();
    e.stopPropagation();
    quickAdd(qa);
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    const qa = e.target.closest && e.target.closest('[data-mk-quickadd]');
    if (!qa) return;
    e.preventDefault();
    quickAdd(qa);
  });

  // ── PDP button price — keep the next ladder rung true after load ──────
  // The price on Add to basket is rendered SERVER-SIDE in Liquid
  // (snippets/product-buy-block.liquid), so it is already correct in the first
  // frame and there is no flicker. This only corrects it when the cart changes
  // WITHOUT a page render: a quick-add from the product row further down the
  // PDP, or a bfcache restore on the back button.
  // The number is the price of the candle this button adds, i.e. the NEXT rung
  // (1st £20, 2nd £15, 3rd and every one after £10 — Ed, 2026-09-12, the £5
  // 4th rung is gone). The welcome-gift
  // candle is invisible to the ladder (the discount Function skips it), so it
  // is excluded here exactly as the buy block and the cart page do. That
  // product id lives in three files now — change them together.
  const MK_GIFT_PRODUCT_ID = 9454813282607;
  const MK_RUNGS = ['£20', '£15', '£10'];
  function paintCtaPrice() {
    const el = $('[data-mk-cta-price]');
    if (!el || !MK.cart) return;
    const paid = (MK.cart.items || []).reduce(
      (n, it) => n + (Number(it.product_id) === MK_GIFT_PRODUCT_ID ? 0 : it.quantity), 0);
    el.textContent = MK_RUNGS[Math.min(Math.max(paid, 0), 2)];
  }
  document.addEventListener('mk:cart', paintCtaPrice);

  // ── PDP gallery — sync dot indicator + counter with scroll position ────
  function bindGalleries() {
    $$('.mk-buy__gallery').forEach(gallery => {
      const stage = gallery.parentElement;
      const buy = stage && stage.parentElement;
      if (!stage || !buy) return;
      const dots = Array.from(buy.querySelectorAll('[data-mk-dot]'));
      const counter = stage.querySelector('[data-mk-counter-i]');
      const slides = gallery.querySelectorAll('.mk-buy__slide');
      // behavior is 'auto', not 'smooth', and must stay that way: the gallery
      // is scroll-snap-type: x mandatory, and a mandatory snap container
      // silently DISCARDS a programmatic smooth scroll. Every thumbnail, both
      // arrows and tap-to-advance were dead from 2026-08-24 until this was
      // found on 2026-08-26. Verified: 'auto' scrolls, 'smooth' does not.
      const setGalleryIndex = (i, behavior = 'auto') => {
        const w = gallery.clientWidth;
        if (!w || !slides.length) return;
        const next = ((i % slides.length) + slides.length) % slides.length;
        gallery.scrollTo({ left: w * next, behavior });
        dots.forEach((d, j) => d.classList.toggle('is-active', j === next));
        buy.querySelectorAll('[data-mk-thumb]').forEach((d) => d.classList.toggle('is-active', parseInt(d.dataset.mkThumb || '0', 10) === next));
        if (counter) counter.textContent = String(next + 1);
      };
      gallery.addEventListener('scroll', () => {
        const w = gallery.clientWidth;
        if (!w) return;
        const i = Math.round(gallery.scrollLeft / w);
        dots.forEach((d, j) => d.classList.toggle('is-active', j === i));
        buy.querySelectorAll('[data-mk-thumb]').forEach((d) => d.classList.toggle('is-active', parseInt(d.dataset.mkThumb || '0', 10) === i));
        if (counter) counter.textContent = String(i + 1);
      }, { passive: true });
      gallery.addEventListener('click', () => {
        const w = gallery.clientWidth;
        if (!w || slides.length < 2) return;
        setGalleryIndex(Math.round(gallery.scrollLeft / w) + 1);
      });
      const goPrev = stage.querySelector('[data-mk-gallery-prev]');
      const goNext = stage.querySelector('[data-mk-gallery-next]');
      if (goPrev) {
        goPrev.addEventListener('click', (e) => {
          e.stopPropagation();
          const w = gallery.clientWidth;
          if (!w || slides.length < 2) return;
          setGalleryIndex(Math.round(gallery.scrollLeft / w) - 1);
        });
      }
      if (goNext) {
        goNext.addEventListener('click', (e) => {
          e.stopPropagation();
          const w = gallery.clientWidth;
          if (!w || slides.length < 2) return;
          setGalleryIndex(Math.round(gallery.scrollLeft / w) + 1);
        });
      }
      buy.querySelectorAll('[data-mk-thumb]').forEach(btn => {
        btn.addEventListener('click', () => {
          const i = parseInt(btn.dataset.mkThumb || '0', 10);
          setGalleryIndex(i);
        });
      });
      // Default to a specific slide on load (e.g. 3rd image = candle + box)
      const defaultIdx = parseInt(gallery.dataset.mkDefaultIdx || '0', 10);
      if (defaultIdx > 0) {
        const jump = () => {
          const w = gallery.clientWidth;
          if (!w) return false;
          gallery.scrollTo({ left: w * defaultIdx, behavior: 'instant' in document.documentElement.style ? 'instant' : 'auto' });
          return true;
        };
        if (!jump()) requestAnimationFrame(jump);
      }
    });
  }

  document.addEventListener('click', (e) => {
    const minus = e.target.closest('[data-mk-qty-minus]');
    const plus = e.target.closest('[data-mk-qty-plus]');
    if (!minus && !plus) return;
    const form = e.target.closest('form');
    const input = form && form.querySelector('[data-mk-qty-input]');
    if (!input) return;
    const current = Math.max(1, parseInt(input.value || '1', 10));
    const next = plus ? current + 1 : Math.max(1, current - 1);
    input.value = String(next);
  });

  // ── Cart add — intercept any form posting to /cart/add: AJAX add, then
  // land on the cart page (the gift list is the post-add surface).
  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();
    const btn = form.querySelector('button[type="submit"]');
    const original = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    const fd = new FormData(form);
    const id = Number(fd.get('id'));
    const quantity = Math.max(1, Number(fd.get('quantity') || 1));
    if (!id) { if (btn) { btn.disabled = false; btn.textContent = original; } return; }
    try {
      await MK.addToCart(id, quantity);
      if (btn) btn.textContent = 'Added';
      window.location.href = '/cart';
    } catch (err) {
      if (btn) { btn.disabled = false; btn.textContent = original; }
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    if (!$('#mk-drawer-nav')?.hidden) { closeNav(); return; }
  });

  // ── Nav drawer (mobile mega-menu) ─────────────────────────────────
  function openNav() {
    const d = $('#mk-drawer-nav');
    if (!d) return;
    d.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function closeNav() {
    const d = $('#mk-drawer-nav');
    if (!d) return;
    d.hidden = true;
    document.body.style.overflow = '';
  }
  document.addEventListener('click', (e) => {
    if (e.target.closest('#mk-navdrawer__open')) { e.preventDefault(); openNav(); return; }
    if (e.target.matches('#mk-navdrawer__close') || e.target.matches('#mk-navdrawer__backdrop')) closeNav();
  });

  // ── Bag drawer ────────────────────────────────────────────────────
  function positionMegaNav(nav) {
    const trigger = nav.querySelector('.mk-meganav__trigger');
    const panel = nav.querySelector('.mk-meganav__panel');
    if (!trigger || !panel) return;

    const oldDisplay = panel.style.display;
    const oldVisibility = panel.style.visibility;
    panel.style.display = 'block';
    panel.style.visibility = 'hidden';
    panel.style.right = 'auto';
    panel.style.transform = 'none';

    const triggerRect = trigger.getBoundingClientRect();
    const navRect = nav.getBoundingClientRect();
    const panelRect = panel.getBoundingClientRect();
    const margin = 24;
    const maxLeft = Math.max(margin, window.innerWidth - panelRect.width - margin);
    const idealLeft = triggerRect.left + (triggerRect.width / 2) - (panelRect.width / 2);
    const clampedLeft = Math.min(Math.max(idealLeft, margin), maxLeft);

    panel.style.left = `${Math.round(clampedLeft - navRect.left)}px`;
    panel.style.display = oldDisplay;
    panel.style.visibility = oldVisibility;
  }

  function bindMegaNavPositioning() {
    const navs = $$('.mk-meganav');
    if (!navs.length) return;
    navs.forEach(nav => {
      nav.addEventListener('mouseenter', () => positionMegaNav(nav));
      nav.addEventListener('focusin', () => positionMegaNav(nav));
      positionMegaNav(nav);
    });
    window.addEventListener('resize', () => navs.forEach(positionMegaNav), { passive: true });
  }

  function bindCartPage() {
    // Gift-list rows are LINES (Ed, 2026-08-07 — they were units until then, and
    // pressing + spawning a duplicate row read as a bug). One row per candle,
    // carrying a [× or −] [n] [+] stepper. Both controls just set a new line
    // quantity; the page reloads and rows, prices, sticker, slot count and
    // subtotal are all re-rendered server-side from the real cart.
    const changeLine = async (lineKey, quantity, row) => {
      if (!lineKey) return;
      if (row) row.classList.add('is-updating');
      const r = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity }),
      });
      touchCart();
      // Crossing off the last candle goes home (Ed, 2026-08-07) — an empty
      // cart page is a dead end; the shop is the better place to land.
      let empty = false;
      try { empty = (await r.json()).item_count === 0; } catch {}
      window.location.href = empty ? '/' : '/cart';
    };

    document.addEventListener('click', (e) => {
      const x = e.target.closest('[data-mk-unit-remove]');
      if (!x) return;
      e.preventDefault();
      if (x.dataset.busy) return;
      x.dataset.busy = '1';
      const qty = Math.max(0, (parseInt(x.dataset.lineQty, 10) || 1) - 1);
      changeLine(x.dataset.lineKey, qty, x.closest('.mkgl__row'));
    });

    // + on a filled row: another of the SAME candle (Ed, 2026-08-07). Shoppers
    // buying two or three of one design had no way to say so — the PDP posts
    // quantity 1 and the card quick-add adds one at a time. Raises the LINE
    // quantity, so the row's number ticks up; no new row appears.
    document.addEventListener('click', (e) => {
      const plus = e.target.closest('[data-mk-unit-add]');
      if (!plus) return;
      e.preventDefault();
      if (plus.dataset.busy) return;
      plus.dataset.busy = '1';
      const qty = (parseInt(plus.dataset.lineQty, 10) || 1) + 1;
      changeLine(plus.dataset.lineKey, qty, plus.closest('.mkgl__row'));
    });

    // + on an EMPTY slot tile: the finder, not a dead icon (Ed, 2026-08-27 —
    // "the plus should lead to search as that's where people are drawn to
    // click"). The tile links to /search so it still works with JS off; here
    // we keep the shopper on the cart and put the cursor in the finder input
    // that sits a few pixels below, which is the same destination with the
    // basket still on screen. Suggestions are already wired to that input.
    document.addEventListener('click', (e) => {
      const find = e.target.closest('[data-mk-find]');
      if (!find) return;
      const input = document.querySelector('.mkb__finder .mk-search__input');
      if (!input) return; // no finder on the page: follow the href
      e.preventDefault();
      (document.querySelector('.mkb__finder') || input).scrollIntoView({ behavior: 'smooth', block: 'center' });
      input.focus();
    });
  }

  // ── Bag count in header ───────────────────────────────────────────
  function paintBagCount() {
    const btn = $('.mk-header__bag');
    if (!btn) return;
    const count = MK.cart?.item_count || 0;
    const existing = btn.querySelector('.mk-header__bag-count');
    if (count > 0) {
      if (existing) existing.textContent = count;
      else btn.insertAdjacentHTML('beforeend', `<span class="mk-header__bag-count" aria-hidden="true">${count}</span>`);
    } else {
      existing?.remove();
    }
    btn.setAttribute('aria-label', `Cart (${count})`);
  }
  document.addEventListener('mk:cart', paintBagCount);

  // ── Recent searches (home only) ───────────────────────────────────
  function paintRecent() {
    const wrap = $('#mk-recent');
    if (!wrap) return;
    if (!MK.recent.length) { wrap.hidden = true; return; }
    wrap.hidden = false;
    wrap.innerHTML = `
      <h2 class="mk-section__heading">Recent searches</h2>
      <div class="mk-pills">
        ${MK.recent.map(q => `
          <a class="mk-pill mk-pill--outline" href="/search?q=${encodeURIComponent(q)}&type=product">${escapeHtml(q)}</a>
        `).join('')}
      </div>
    `;
  }
  document.addEventListener('mk:recent', paintRecent);

  // ── Search client: Algolia behind a flag, native suggest.json under it ──
  // Plan: website/log/2026-08-05_algolia-search-build-plan.md (WP2).
  // window.MK_ALGOLIA is emitted by theme.liquid ONLY when the theme setting
  // algolia_enabled is ticked; absent = every surface uses native
  // suggest.json exactly as before. Bot/quota gating (plan §2): Algolia may
  // only fire after a real (isTrusted) keystroke, and never for
  // navigator.webdriver sessions — bots get native, which is free. ANY
  // Algolia failure (the rate-limited key's 429 included) falls back to
  // native silently. MK_ALGOLIA.force is a console-only debug override for
  // the trust gate (synthetic test events are untrusted by design).
  // Trust survives navigation via sessionStorage (WP3): the results page
  // loads AFTER the trusted keystroke happened on the previous page, so the
  // flag must persist. pointerdown covers no-typing journeys (recent-search
  // pills, suggestion rows). Bots that merely fetch or render never interact,
  // so they still get native.
  let algTrusted = false;
  try { algTrusted = sessionStorage.getItem('mk-alg-trust') === '1'; } catch (_) {}
  const algMarkTrust = (e) => {
    if (!e.isTrusted) return;
    algTrusted = true;
    try { sessionStorage.setItem('mk-alg-trust', '1'); } catch (_) {}
  };
  document.addEventListener('keydown', algMarkTrust, true);
  document.addEventListener('pointerdown', algMarkTrust, true);
  const algOn = () => {
    const c = window.MK_ALGOLIA;
    return !!(c && c.enabled && c.appId && c.searchKey &&
              (c.force || (algTrusted && !navigator.webdriver)));
  };
  async function algQuery(requests) {
    const c = window.MK_ALGOLIA;
    const r = await fetch(`https://${c.appId.toLowerCase()}-dsn.algolia.net/1/indexes/*/queries`, {
      method: 'POST',
      headers: { 'X-Algolia-Application-Id': c.appId, 'X-Algolia-API-Key': c.searchKey },
      body: JSON.stringify({ requests }),
    });
    if (!r.ok) throw new Error('algolia ' + r.status);
    return (await r.json()).results;
  }
  // One product shape for every surface; price ALWAYS lands in PENCE for
  // money(). Algolia records carry pence natively (our own schema). Native
  // suggest.json returns pounds as a string ("20.00") — the 2026-07-30
  // £0.20-instead-of-£20 regression — but has been seen reporting pence too
  // (pick-sheet's old ÷100 hedge), so values over 500 are treated as pence:
  // no single candle costs more than £500, and a pence-mood "2000" must not
  // render as £2,000.
  const poundsOrPence = (raw) => {
    const v = parseFloat(raw);
    if (!isFinite(v)) return 0;
    return Math.round(v > 500 ? v : v * 100);
  };
  // Records and suggest.json both carry FULL-SIZE image URLs; always ask
  // Shopify's CDN for a thumbnail or a 36px row downloads a multi-MB file.
  const algThumb = (u) => u ? u + (u.includes('?') ? '&' : '?') + 'width=120' : '';
  MK.searchProducts = async function (q, limit) {
    if (algOn()) {
      try {
        const [res] = await algQuery([{ indexName: 'makester_products', query: q,
                                        params: 'hitsPerPage=' + limit }]);
        return res.hits.map(h => ({
          title: h.title, url: h.url, handle: h.handle, img: h.image || '',
          pricePence: h.price || 0,
          variantId: h.variant_id ? String(h.variant_id) : '',
        }));
      } catch { /* fall through to native */ }
    }
    const r = await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=${limit}`);
    const products = (await r.json()).resources?.results?.products || [];
    return products.map(p => ({
      title: p.title, url: p.url, handle: p.handle,
      img: (p.featured_image && p.featured_image.url) || p.image || '',
      pricePence: poundsOrPence(p.price),
      variantId: (p.variants && p.variants[0] && p.variants[0].id) ? String(p.variants[0].id) : '',
    }));
  };

  // ── Search results page: Algolia ranking behind the flag (plan WP3) ─────
  // templates/search.liquid ALWAYS renders the native results server-side —
  // that page is the fallback for bots, no-JS, flag-off and any Algolia
  // failure, so nothing here may run unless Algolia answers WITH hits: then
  // the native grid + pager (or native empty state) are replaced by
  // Algolia-ranked cards. On any other outcome (no trust, error, 0 hits) the
  // native page stays untouched — deliberately looser than the plan's
  // zero-state wording, because a stale index knowing nothing about a query
  // the native grid CAN answer must not blank real results.
  // Algolia keeps its own fetch/append handler, but its pager is armed by the
  // same IntersectionObserver as collection pages so every product grid now
  // advances on scroll. data-mk-alg-more distinguishes the Algolia fetch from
  // the native HTML-page fetch used by data-mk-next-page.
  const ALG_PAGE_SIZE = 24;
  function algCardHtml(h, i, page) {
    const img = h.image || '';
    const eager = page === 0 && i < 9; // mirror search.liquid's LCP rule
    const w = (n) => img + (img.includes('?') ? '&' : '?') + 'width=' + n;
    return `
      <a class="mk-card" href="${escapeHtml(h.url)}" data-handle="${escapeHtml(h.handle || '')}">
        <div class="mk-card__media">
          ${img ? `<img class="mk-card__image" src="${escapeHtml(w(600))}" srcset="${escapeHtml(w(200))} 200w, ${escapeHtml(w(300))} 300w, ${escapeHtml(w(400))} 400w, ${escapeHtml(w(600))} 600w, ${escapeHtml(w(800))} 800w" sizes="(min-width: 1024px) 330px, 31vw" alt="" loading="${eager ? 'eager' : 'lazy'}"${eager ? ' fetchpriority="high"' : ''}>` : ''}
          ${h.variant_id ? `<span class="mk-card__quickadd" role="button" tabindex="0" data-mk-quickadd data-variant="${escapeHtml(String(h.variant_id))}" aria-label="Add ${escapeHtml(h.title)} to basket"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg></span>` : ''}
        </div>
        <div class="mk-card__body"><h3 class="mk-card__title">${escapeHtml(h.title)}</h3></div>
      </a>`;
  }
  function renderAlgPager(root, q, res) {
    const old = root.querySelector('[data-mk-alg-pager]');
    if (old) old.remove();
    const shown = Math.min((res.page + 1) * ALG_PAGE_SIZE, res.nbHits);
    if (shown >= res.nbHits) return;
    const nav = document.createElement('nav');
    nav.className = 'mk-pagination';
    nav.setAttribute('data-mk-alg-pager', '');
    nav.setAttribute('data-mk-pagination', '');
    nav.setAttribute('data-mk-autoload', '');
    nav.setAttribute('aria-label', 'Search results pagination');
    // href = the native page for the same depth: the graceful path if the
    // next Algolia fetch fails mid-browse.
    nav.innerHTML = `
      <a class="mk-pagination__more" data-mk-alg-more href="/search?type=product&q=${encodeURIComponent(q)}&page=${res.page + 2}">
        <span>Show more candles</span>
        <small>${shown} of ${res.nbHits} shown</small>
      </a>`;
    root.appendChild(nav);
    nav.querySelector('[data-mk-alg-more]').addEventListener('click', async (e) => {
      e.preventDefault();
      const link = e.currentTarget;
      if (link.classList.contains('is-loading')) return;
      const auto = link.hasAttribute('data-mk-auto-load');
      link.removeAttribute('data-mk-auto-load');
      link.classList.add('is-loading');
      const status = nav.querySelector('.mk-pagination__status');
      if (status) status.classList.add('is-loading');
      try {
        const [next] = await algQuery([{ indexName: 'makester_products', query: q,
          params: 'hitsPerPage=' + ALG_PAGE_SIZE + '&page=' + (res.page + 1) }]);
        const listEl = root.querySelector('[data-mk-alg-list]');
        const tpl = document.createElement('template');
        tpl.innerHTML = next.hits.map((h, i) => algCardHtml(h, i, next.page)).join('');
        listEl.append(tpl.content);
        autoLoadCount = auto ? autoLoadCount + 1 : 0;
        renderAlgPager(root, q, next);
        paintQuickAdds();
      } catch (_) {
        window.location.href = link.href;
      }
    });
    observePager(nav);
  }
  let algSearchDone = false;
  async function bindAlgSearch() {
    if (algSearchDone) return;
    if (location.pathname !== '/search') return;
    const q = (new URLSearchParams(location.search).get('q') || '').trim();
    if (!q) return;
    const root = document.querySelector('.mk-collection[data-mk-paginated]');
    if (!root || !algOn()) return;
    let products, colls;
    try {
      [products, colls] = await algQuery([
        { indexName: 'makester_products', query: q,
          params: 'hitsPerPage=' + ALG_PAGE_SIZE + '&page=0' },
        // Hero cards must be REAL matches: title/alias/handle only ("house"
        // in dog body copy must never hero Dog Gifts) and no drop-a-word
        // fallback — both query-time overrides, index settings untouched.
        { indexName: 'makester_collections', query: q,
          params: 'hitsPerPage=2&removeWordsIfNoResults=none&restrictSearchableAttributes=' +
                  encodeURIComponent('title,estate_aliases,handle') },
      ]);
    } catch (_) { return; }
    if (!products || !products.nbHits) return; // keep the native page
    algSearchDone = true;
    let html = '';
    const cards = ((colls && colls.hits) || []).filter(h => h.products_count > 0);
    if (cards.length) {
      html += '<div class="mk-scards">' + cards.map(h => `
        <a class="mk-scard" href="${escapeHtml(h.url)}">
          ${h.image ? `<img class="mk-scard__img" src="${escapeHtml(h.image + (h.image.includes('?') ? '&' : '?') + 'width=160')}" alt="" loading="lazy">` : ''}
          <span class="mk-scard__body">
            <span class="mk-scard__kicker">Collection</span>
            <span class="mk-scard__title">${escapeHtml(h.title)}</span>
          </span>
          <span class="mk-scard__count">${h.products_count} candles</span>
          <span class="mk-scard__arrow">&rsaquo;</span>
        </a>`).join('') + '</div>';
    }
    html += '<div class="mk-grid" data-mk-alg-list>' +
      products.hits.map((h, i) => algCardHtml(h, i, 0)).join('') + '</div>';
    const mount = document.createElement('div');
    mount.setAttribute('data-mk-alg-results', '');
    mount.innerHTML = html;
    const list = root.querySelector('[data-mk-list]');
    const pager = root.querySelector('[data-mk-pagination]');
    const empty = root.querySelector('[data-mk-search-empty]');
    if (list) list.replaceWith(mount);
    else if (empty) empty.replaceWith(mount);
    else root.appendChild(mount);
    if (pager) {
      if (pagerObserver) pagerObserver.unobserve(pager);
      pager.remove();
    }
    renderAlgPager(root, q, products);
    paintQuickAdds();
  }
  MK.bindAlgSearch = bindAlgSearch; // debug rerun (pair with MK_ALGOLIA.force)

  // -- Search suggestion dropdowns: REMOVED 2026-08-31 (Ed) ----------
  // Two dropdowns used to live here: wireSuggest() painted product cards
  // (thumb + title + price) under every .mk-search__input, and
  // wireHeaderSuggest() painted text rows under the header box and the
  // homepage hero. Both are gone.
  //
  // Ed's reasoning, from watching two real buyers use them on 30 Aug: at
  // thumbnail size a candle label is unreadable, and our product names
  // ('Bestie Knows Too Much', 'A Bit Quirky') mean nothing out of context.
  // The search RESULTS page shows the label big enough to read AND already
  // puts matching collections above the grid (see bindAlgSearch), so the
  // shopper should complete the search and land there.
  //
  // If a dropdown is ever wanted back it is in git, not here. Do not
  // reintroduce one without Ed: this was a deliberate call, not an oversight.

  // ── Search form submit → push recent ─────────────────────────────
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (form.matches?.('form[action="/search"]')) {
      const q = form.querySelector('input[name="q"]')?.value;
      if (q) MK.pushRecent(q);
    }
  });

  // ── Candle Club saved grid (dynamic) ──────────────────────────────
  async function paintClubSaved() {
    const grid = $('#mk-club-saved');
    if (!grid) return;
    if (!MK.saved.length) {
      grid.innerHTML = `<p class="mk-club__empty">Tap the heart on any candle to save it here.</p>`;
      return;
    }
    const cards = await Promise.all(MK.saved.map(async handle => {
      try {
        const p = await MK.fetchProduct(handle);
        const cardSrc = p.featured_image || (p.images || [])[0];
        return `
          <a class="mk-card" href="/products/${p.handle}" data-handle="${p.handle}">
            <button type="button" class="mk-card__heart" aria-pressed="true" data-handle="${p.handle}">&#9829;</button>
            <div class="mk-card__media">
              <img class="mk-card__image" src="${cardSrc}" alt="${escapeHtml(p.title)}">
            </div>
            <div class="mk-card__body">
              <h3 class="mk-card__title">${escapeHtml(p.title)}</h3>
            </div>
          </a>
        `;
      } catch { return ''; }
    }));
    grid.innerHTML = cards.join('');
  }
  document.addEventListener('mk:saved', paintClubSaved);

  // ── Self-typing search (homepage v4) ──────────────────────────────
  function bindTypeSearch() {
    const root = $('[data-mk-typesearch]');
    if (!root) return;
    const queries = window.MK_TS_QUERIES || [];
    if (!queries.length) return;

    const box      = root.querySelector('[data-mk-typesearch-box]');
    const input    = root.querySelector('[data-mk-typesearch-input]');
    const caret    = root.querySelector('[data-mk-typesearch-caret]');
    const labelEl  = root.querySelector('[data-mk-typesearch-label]');
    const countEl  = root.querySelector('[data-mk-typesearch-count]');
    const rowsEl   = root.querySelector('[data-mk-typesearch-rows]');
    const allEl    = root.querySelector('[data-mk-typesearch-all]');
    const allQ     = root.querySelector('[data-mk-typesearch-all-q]');

    const renderQuery = (qIdx) => {
      const q = queries[qIdx];
      if (!q) return;
      labelEl.textContent = q.label;
      countEl.textContent = `${q.rows.length} of ${q.total || q.rows.length}`;
      // Showcase rows link to the query's LIVE collection, never to /search
      // (Ed, 2026-08-06): a demo click on /search?q=… is logged by Shopify as a
      // real customer search and was polluting what search_boost learns from.
      // Rationale + verified destinations: sections/hero-search.liquid.
      const dest = q.url || '/collections/all-gifts';
      allEl.setAttribute('href', dest);
      allQ.textContent = q.q;
      rowsEl.innerHTML = q.rows.map((r, i) => `
        <a class="mk-suggest__row" href="${dest}" style="animation-delay:${i * 60}ms">
          <img src="${escapeHtml(r.img)}" alt="" loading="lazy">
          <div class="mk-suggest__col">
            <div class="mk-suggest__title">${escapeHtml(r.title)}</div>
            <div class="mk-suggest__sub">${escapeHtml(r.sub)}</div>
          </div>
          <span class="mk-suggest__arrow" aria-hidden="true">&rarr;</span>
        </a>
      `).join('');
      // re-trigger fade animation
      rowsEl.style.animation = 'none';
      void rowsEl.offsetWidth;
      rowsEl.style.animation = '';
      labelEl.style.animation = 'none';
      void labelEl.offsetWidth;
      labelEl.style.animation = '';
    };

    let qIndex = 0;
    let phase = 'holding';
    let paused = false;
    let userMode = false;
    input.value = queries[0].q;
    // Query 0 is server-rendered in hero-search.liquid so the panel arrives at
    // full height (no layout shift). Only paint it here if the rows are missing.
    if (!rowsEl.children.length) renderQuery(0);
    box.dataset.phase = phase;

    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const HOLD_MS = 3800;
    const SWAP_MS = 360;

    let timer = null;
    const stop = () => { if (timer) { clearTimeout(timer); timer = null; } };

    const setPhase = (p) => {
      phase = p;
      box.dataset.phase = p;
      if (caret) caret.hidden = (p === 'holding') || userMode;
    };

    const step = () => {
      if (paused || userMode) { timer = setTimeout(step, 200); return; }
      if (phase === 'holding') {
        qIndex = (qIndex + 1) % queries.length;
        input.value = queries[qIndex].q;
        renderQuery(qIndex);
        setPhase('typing');
        timer = setTimeout(step, SWAP_MS);
      } else if (phase === 'typing') {
        setPhase('holding');
        timer = setTimeout(step, HOLD_MS);
      }
    };

    if (!reduced) timer = setTimeout(step, HOLD_MS);

    input.addEventListener('focus', () => {
      userMode = true;
      paused = true;
      root.classList.add('is-user-mode');
      input.value = '';
      setPhase('holding');
    });
    input.addEventListener('blur', () => {
      if (!input.value) {
        userMode = false;
        paused = false;
        root.classList.remove('is-user-mode');
        root.classList.remove('is-live');
        input.value = queries[qIndex].q;
        renderQuery(qIndex); // hand the panel back to the demo
      }
    });
    root.addEventListener('mouseenter', () => { if (!userMode) paused = true; });
    root.addEventListener('mouseleave', () => { if (!userMode) paused = false; });

    // ── No dropdown while the shopper types (Ed, 2026-08-31) ──────────
    // This input used to get the header dropdown, and `is-live` hid the
    // showcase behind it. Both are gone: the shopper types and presses
    // Search, and the results page does the work. `is-live` is NOT set any
    // more — setting it with no dropdown to overlay would leave a hole the
    // height of the panel, because that reserved height is the homepage's
    // own CLS guard. The showcase simply stays put while she types.
    input.addEventListener('input', () => {
      if (!userMode) return;
      if (!input.value.trim()) renderQuery(qIndex); // emptied: ambient panel back
    });

    // The input still holds a demo query until the shopper focuses it, so
    // tapping "Search →" without typing used to submit the showcase's own word
    // as a real search. Same reason as the row links above: send them to the
    // collection instead, and only let a genuinely typed query reach /search.
    const form = root.querySelector('form');
    if (form) {
      form.addEventListener('submit', (e) => {
        if (!userMode || !input.value.trim()) {
          e.preventDefault();
          window.location.href = (queries[qIndex] && queries[qIndex].url) || '/collections/all-gifts';
        }
      });
    }
  }

  // ── Popular collections — slow ambient drift ──────────────────────
  // The rail creeps sideways on its own (mobile, where it overflows); any
  // touch/scroll from the user pauses it for a while. Ping-pongs at the ends.
  function bindCollectionsDrift() {
    const rail = $('.mk-pdp__collections-rail');
    if (!rail) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    let dir = 1, pausedUntil = 0, acc = 0;
    const pause = () => { pausedUntil = Date.now() + 4000; };
    ['touchstart', 'wheel', 'pointerdown'].forEach(t => rail.addEventListener(t, pause, { passive: true }));
    function tick() {
      const max = rail.scrollWidth - rail.clientWidth;
      if (max > 8 && Date.now() > pausedUntil) {
        acc += 0.35 * dir;                       // ~21px/s
        if (Math.abs(acc) >= 1) {
          rail.scrollLeft += acc | 0;
          acc -= acc | 0;
          if (rail.scrollLeft >= max - 1) dir = -1;
          else if (rail.scrollLeft <= 1) dir = 1;
        }
      }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  // ── PDP reviews — peel stack ──────────────────────────────────────
  // Cards are REAL Judge.me reviews (same widget endpoints the old rail used):
  // this product's reviews first, topped up with site-wide ones so sparse
  // products still get a full pile. Top card follows the pointer; past the
  // threshold it peels away and the next review surfaces.
  async function bindReviewPeel() {
    $$('[data-mk-revstack]').forEach(bindOneReviewPeel);
  }

  // One stack. With a product id the pile leads with that product's reviews
  // topped up site-wide; without one (home page) it's site-wide only.
  async function bindOneReviewPeel(stack) {
    const shop = stack.dataset.mkJudgemeShop;
    const productId = stack.dataset.mkJudgemeProductId || '';
    if (!shop) return;

    const clean = (s) => String(s || '')
      .replace(/<[^>]+>/g, ' ')
      .replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"').replace(/&#39;|&apos;/g, "'")
      .replace(/\s+/g, ' ').trim();

    const parseReviews = (html) => {
      const out = [];
      if (!html) return out;
      const doc = new DOMParser().parseFromString(`<div>${html}</div>`, 'text/html');
      doc.querySelectorAll('.jdgm-rev').forEach(el => {
        const rating = el.querySelector('.jdgm-rev__rating');
        const body = clean(el.querySelector('.jdgm-rev__body p, .jdgm-rev__body')?.textContent || '');
        if (body.replace(/[^A-Za-z0-9]/g, '').length < 12) return;
        // Location arrives as "(Hereford, GB)", strip parens, read GB as UK
        const location = clean(el.querySelector('.jdgm-rev__location')?.textContent || '')
          .replace(/^\(|\)$/g, '').replace(/,\s*GB$/, ', UK');
        out.push({
          score: parseInt(rating?.dataset.score || '5', 10),
          author: clean(el.querySelector('.jdgm-rev__author')?.textContent || 'Verified buyer'),
          title: clean(el.querySelector('.jdgm-rev__title')?.textContent || ''),
          body,
          verified: el.dataset.verifiedBuyer === 'true',
          location,
          date: fmtDate(el.querySelector('.jdgm-rev__timestamp')?.dataset.content || ''),
        });
      });
      return out;
    };

    const fmtDate = (raw) => {
      const t = Date.parse(String(raw).replace(' UTC', 'Z').replace(' ', 'T'));
      if (!Number.isFinite(t)) return '';
      return new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }).format(new Date(t));
    };

    let reviews = [];
    const cacheKey = `mk_rev_peel_v2_${productId || 'site'}`;
    try { reviews = JSON.parse(sessionStorage.getItem(cacheKey)) || []; } catch {}
    if (!reviews.length) {
      const productUrl = `https://cache.judge.me/widgets/shopify/${shop}?product_id=${encodeURIComponent(productId)}&reviews_widget=1&page=1&json_request=1`;
      const siteUrl = `https://cache.judge.me/widgets/shopify/${shop}?all_reviews_rating=1&all_reviews_count=1&all_reviews_page=1&json_request=1`;
      const [prod, site] = await Promise.all([
        productId ? fetch(productUrl).then(r => r.ok ? r.json() : null).catch(() => null) : Promise.resolve(null),
        fetch(siteUrl).then(r => r.ok ? r.json() : null).catch(() => null),
      ]);
      const own = parseReviews(prod && (prod.all_reviews || prod.html_miracle || prod.widget || prod.html || ''));
      const wide = parseReviews(site && (site.all_reviews || site.html_miracle || ''));
      // Bias toward lively reviews: a real title and a body with some meat rank
      // above one-worders, while this product's own reviews stay ahead of
      // site-wide top-ups.
      const liveliness = (r) => (r.body.length >= 60 ? 2 : r.body.length >= 30 ? 1 : 0) + (r.title.length >= 8 ? 1 : 0);
      const rank = (list) => list.map((r, i) => [r, i]).sort((a, b) => liveliness(b[0]) - liveliness(a[0]) || a[1] - b[1]).map(x => x[0]);
      const seen = new Set();
      for (const r of [...rank(own), ...rank(wide)]) {
        if (r.score < 4) continue;
        const key = `${r.author}|${r.body.slice(0, 40)}`;
        if (seen.has(key)) continue;
        seen.add(key);
        reviews.push(r);
        if (reviews.length >= 6) break;
      }
      try { sessionStorage.setItem(cacheKey, JSON.stringify(reviews)); } catch {}
    }
    if (reviews.length < 2) return; // too thin for a pile — stack stays hidden

    const starsSvg = (score, size) => [1,2,3,4,5].map(i =>
      `<svg width="${size}" height="${size}" viewBox="0 0 24 24"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" fill="${i <= score ? 'currentColor' : 'transparent'}" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"/></svg>`).join('');
    const heartsSvg = [1,2,3].map(i =>
      `<svg width="7" height="7" viewBox="0 0 24 24"><path d="M12 21s-7-4.35-9.5-8.5C1 9 3 5.5 6.5 5.5c2 0 3.5 1.5 5.5 3.5 2-2 3.5-3.5 5.5-3.5C21 5.5 23 9 21.5 12.5 19 16.65 12 21 12 21z" fill="${i === 2 ? 'currentColor' : 'rgba(31,24,19,0.28)'}"/></svg>`).join('');
    const trunc = (s, n) => s.length <= n ? s : s.slice(0, n).replace(/\s+\S*$/, '') + '…';

    stack.innerHTML = reviews.map(r => {
      const title = r.title ? trunc(r.title, 44) : trunc(r.body, 34);
      const body = r.title ? trunc(r.body, 150) : trunc(r.body, 170);
      return `
        <div class="mk-rev__card">
          <div class="mk-rev__card-title">${escapeHtml(title)}</div>
          <div class="mk-rev__card-hearts" aria-hidden="true">${heartsSvg}</div>
          <p class="mk-rev__card-body">${escapeHtml(body)}</p>
          <div class="mk-rev__card-byline">
            <span class="mk-rev__card-stars" role="img" aria-label="${r.score} out of 5">${starsSvg(r.score, 11)}</span>
            <span class="mk-rev__card-name">&mdash; ${escapeHtml(r.author)}</span>
          </div>
          <div class="mk-rev__card-foot">
            <div>
              <div class="mk-rev__card-foot-line">Luxury hand poured candle</div>
              <div class="mk-rev__card-foot-line mk-rev__card-foot-line--dim">${escapeHtml(
                [r.verified ? '✓ Verified buyer' : 'Buyer review',
                 r.location, r.date].filter(Boolean).join(' · ')
              )}</div>
            </div>
            <span class="mk-rev__card-mark">makester</span>
          </div>
        </div>`;
    }).join('');
    stack.hidden = false;

    const cards = $$('.mk-rev__card', stack);
    if (cards.length < 2) return;
    let order = cards.map((_, k) => k);
    let dragX = 0, x0 = 0, dragging = false, leaving = false, touched = false;

    const paint = () => {
      order.forEach((idx, depth) => {
        const el = cards[idx];
        el.style.zIndex = String(10 - depth);
        el.classList.toggle('is-top', depth === 0);
        el.hidden = depth > 3;
        if (depth === 0) {
          el.style.transform = dragX ? `translateX(${dragX}px) rotate(${dragX / 26}deg)` : '';
        } else {
          // hand-stacked jumble: small alternating rotations, but the per-depth
          // shrink (5%) insets each card further than the rotated corners swing
          // out (~5-7px), so nothing pokes past the card above.
          // FAN is indexed modulo its length: a bare [depth] lookup returned
          // undefined past depth 3, which made the whole transform string
          // invalid, so the assignment was dropped and a just-peeled card kept
          // the translateX from the drag, it hung off the left of the pile
          // instead of going to the back.
          const FAN = [0, 2.4, -2.8, 1.6];
          const fan = FAN[depth % FAN.length];
          const depthClamped = Math.min(depth, 3);
          el.style.transform = `translateY(${depthClamped * 8}px) scale(${1 - depthClamped * 0.05}) rotate(${fan}deg)`;
        }
      });
      stack.classList.toggle('is-teasing', !touched && !leaving);
    };

    const advance = (dir) => {
      if (leaving) return;
      leaving = true;
      const top = cards[order[0]];
      top.classList.add(dir === 1 ? 'is-peel-l' : 'is-peel-r');
      setTimeout(() => {
        top.classList.remove('is-peel-l', 'is-peel-r');
        order.push(order.shift());
        dragX = 0; leaving = false;
        paint();
      }, 340);
    };

    const down = (e) => {
      touched = true; dragging = true;
      x0 = (e.touches ? e.touches[0] : e).clientX;
      stack.classList.add('is-grab');
      paint();
    };
    const move = (e) => {
      if (!dragging || leaving) return;
      dragX = (e.touches ? e.touches[0] : e).clientX - x0;
      paint();
    };
    const up = () => {
      if (!dragging) return;
      dragging = false;
      stack.classList.remove('is-grab');
      if (Math.abs(dragX) > 56) advance(dragX < 0 ? 1 : -1);
      else { dragX = 0; paint(); }
    };
    stack.addEventListener('mousedown', down);
    stack.addEventListener('mousemove', move);
    stack.addEventListener('mouseup', up);
    stack.addEventListener('mouseleave', up);
    stack.addEventListener('touchstart', down, { passive: true });
    stack.addEventListener('touchmove', move, { passive: true });
    stack.addEventListener('touchend', up);
    paint();
  }

  // ── PDP reviews — the mobile list ─────────────────────────────────
  // Same Judge.me widget endpoints as the peel stack, rendered as a plain
  // scannable list instead: five at a time, recency first, each row carrying
  // the candle that person actually bought (so the proof section merchandises
  // the range too) and linking to it.
  //
  // NOTE ON PAGING: cache.judge.me's widget endpoint ignores its page param —
  // every page returns the same ~25 reviews (verified 2026-08-05). So "Show 5
  // more" walks the pool we already hold, and once that runs dry the button
  // becomes a link to the full reviews page rather than pretending to page.
  // Real server-side paging needs the authenticated Judge.me API.
  async function bindReviewList() {
    const root = $('[data-mk-revlist]');
    if (!root) return;
    const shop = root.dataset.mkJudgemeShop;
    const productId = root.dataset.mkJudgemeProductId || '';
    const allUrl = root.dataset.mkReviewsUrl || '/pages/reviews';
    const total = root.dataset.mkReviewsTotal || '';
    const rowsEl = root.querySelector('[data-mk-revlist-rows]');
    const moreEl = root.querySelector('[data-mk-revlist-more]');
    if (!shop || !rowsEl || !moreEl) return;

    const clean = (s) => String(s || '')
      .replace(/<[^>]+>/g, ' ')
      .replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"').replace(/&#39;|&apos;/g, "'")
      .replace(/�/g, '')
      .replace(/\s+/g, ' ').trim();

    const fmtDate = (raw) => {
      const t = Date.parse(String(raw).replace(' UTC', 'Z').replace(' ', 'T'));
      if (!Number.isFinite(t)) return '';
      return new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }).format(new Date(t));
    };

    // Same shape as the peel stack's parser plus the product each review is
    // attached to — that is what the row's thumbnail and eyebrow render from.
    const parse = (html) => {
      const out = [];
      if (!html) return out;
      const doc = new DOMParser().parseFromString(`<div>${html}</div>`, 'text/html');
      doc.querySelectorAll('.jdgm-rev').forEach(el => {
        const body = clean(el.querySelector('.jdgm-rev__body p, .jdgm-rev__body')?.textContent || '');
        if (body.replace(/[^A-Za-z0-9]/g, '').length < 12) return;
        const prodLink = el.querySelector('.jdgm-rev__prod-link');
        const img = el.querySelector('.jdgm-rev__pic-img');
        out.push({
          score: parseInt(el.querySelector('.jdgm-rev__rating')?.dataset.score || '5', 10),
          author: clean(el.querySelector('.jdgm-rev__author')?.textContent || 'Verified buyer'),
          title: clean(el.querySelector('.jdgm-rev__title')?.textContent || ''),
          body,
          verified: el.dataset.verifiedBuyer === 'true',
          location: clean(el.querySelector('.jdgm-rev__location')?.textContent || '')
            .replace(/^\(|\)$/g, '').replace(/,\s*GB$/, ''),
          date: fmtDate(el.querySelector('.jdgm-rev__timestamp')?.dataset.content || ''),
          product: clean(prodLink?.textContent || ''),
          url: (prodLink?.getAttribute('href') || '').split('#')[0],
          img: img?.getAttribute('data-src') || img?.getAttribute('src') || '',
        });
      });
      return out;
    };

    // Five-star share comes off the site-wide histogram in the same payload:
    // rows carry data-rating / data-percentage, so no scraping of rendered text.
    const parseFiveStar = (html) => {
      if (!html) return 0;
      const doc = new DOMParser().parseFromString(`<div>${html}</div>`, 'text/html');
      const row = doc.querySelector('.jdgm-histogram__row[data-rating="5"]');
      const pct = parseInt(row?.getAttribute('data-percentage') || '0', 10);
      return Number.isFinite(pct) ? pct : 0;
    };

    let pool = [];
    let fiveStar = 0;
    const cacheKey = `mk_rev_list_v2_${productId || 'site'}`;
    try {
      const cached = JSON.parse(sessionStorage.getItem(cacheKey)) || null;
      if (cached && Array.isArray(cached.pool)) { pool = cached.pool; fiveStar = cached.fiveStar || 0; }
    } catch {}
    if (!pool.length) {
      const productUrl = `https://cache.judge.me/widgets/shopify/${shop}?product_id=${encodeURIComponent(productId)}&reviews_widget=1&page=1&json_request=1`;
      const siteUrl = `https://cache.judge.me/widgets/shopify/${shop}?all_reviews_rating=1&all_reviews_count=1&all_reviews_page=1&json_request=1`;
      const [prod, site] = await Promise.all([
        productId ? fetch(productUrl).then(r => r.ok ? r.json() : null).catch(() => null) : Promise.resolve(null),
        fetch(siteUrl).then(r => r.ok ? r.json() : null).catch(() => null),
      ]);
      // This product's own reviews lead; site-wide tops up so a new candle
      // still shows a full section.
      const own = parse(prod && (prod.all_reviews || prod.html_miracle || prod.widget || prod.html || ''));
      const wide = parse(site && (site.all_reviews || site.html_miracle || ''));
      const seen = new Set();
      for (const r of [...own, ...wide]) {
        const key = `${r.author}|${r.body.slice(0, 40)}`;
        if (seen.has(key)) continue;
        seen.add(key);
        pool.push(r);
      }
      fiveStar = parseFiveStar(site && site.all_reviews_header);
      try { sessionStorage.setItem(cacheKey, JSON.stringify({ pool, fiveStar })); } catch {}
    }
    if (pool.length < 3) return;   // too thin to be worth a section

    const fiveEl = $('[data-mk-five]');
    if (fiveEl && fiveStar > 0) {
      fiveEl.innerHTML = `&middot; <strong>${fiveStar}%</strong> five stars`;
      fiveEl.hidden = false;
    }

    const starsSvg = (score) => [1, 2, 3, 4, 5].map(i =>
      `<svg width="12" height="12" viewBox="0 0 24 24"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" fill="${i <= score ? 'currentColor' : 'transparent'}" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/></svg>`).join('');
    const sized = (u) => u ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';

    const rowHtml = (r) => {
      const who = [escapeHtml(r.author), escapeHtml(r.location), escapeHtml(r.date)].filter(Boolean).join(' &middot; ');
      const meta = (r.verified ? '<span class="mk-rvrow__tick">&#10003;</span> ' : '') + who;
      return `<a class="mk-rvrow" href="${escapeHtml(r.url || allUrl)}">
        ${r.img ? `<img src="${escapeHtml(sized(r.img))}" alt="${escapeHtml(r.product)}" loading="lazy" width="62" height="78">` : '<span></span>'}
        <div class="mk-rvrow__body">
          <div class="mk-rvrow__top"><span class="mk-rvrow__stars" role="img" aria-label="${r.score} out of 5">${starsSvg(r.score)}</span><span class="mk-rvrow__prod">${escapeHtml(r.product)}</span></div>
          ${r.title ? `<div class="mk-rvrow__t">${escapeHtml(r.title)}</div>` : ''}
          <p class="mk-rvrow__b">${escapeHtml(r.body)}</p>
          <div class="mk-rvrow__who">${meta}</div>
        </div>
      </a>`;
    };

    const PAGE = 5;
    let shown = 0;
    function paintMore() {
      const next = pool.slice(shown, shown + PAGE);
      rowsEl.insertAdjacentHTML('beforeend', next.map(rowHtml).join(''));
      shown += next.length;
      // One control, not two: it keeps revealing while there are reviews left
      // in the pool, then turns into the way to read the rest.
      if (shown < pool.length) {
        // Plain "View more" (Ed, 2026-08-26) — the count belongs to the
        // heading above, not to the control that reveals the next five.
        moreEl.textContent = 'View more';
        moreEl.hidden = false;
      } else if (total) {
        moreEl.textContent = `Read all ${total} reviews →`;
        moreEl.dataset.mkGo = allUrl;
        moreEl.hidden = false;
      } else {
        moreEl.hidden = true;
      }
    }
    moreEl.addEventListener('click', () => {
      if (moreEl.dataset.mkGo) { window.location.href = moreEl.dataset.mkGo; return; }
      paintMore();
    });
    paintMore();
    root.hidden = false;
  }

  // The flat-lay section's search opens the existing pick sheet — the same
  // search surface the empty slots use, so there is still only one of them.
  // ── Judge.me — pull live reviews for the current product ─────────
  function bindJudgeme() {
    const root = $('[data-mk-judgeme]');
    if (!root) return;
    const shop = root.dataset.mkJudgemeShop;
    const productId = root.dataset.mkJudgemeProductId;
    if (!shop || !productId) return;

    const railEl  = root.querySelector('[data-mk-judgeme-rail]');
    const prevBtn = root.querySelector('[data-mk-reviews-prev]');
    const nextBtn = root.querySelector('[data-mk-reviews-next]');
    const ratingEl = root.querySelector('[data-mk-judgeme-rating]');
    const countEl  = root.querySelector('[data-mk-judgeme-count]');
    const pqBody = root.querySelector('[data-mk-judgeme-pullquote-body]');
    const pqFoot = root.querySelector('[data-mk-judgeme-pullquote-foot]');

    const cacheKey = `mk_jdgm_${productId}`;
    const cached = sessionStorage.getItem(cacheKey);
    if (cached) {
      try { renderJudgeme(JSON.parse(cached)); } catch (_) {}
    }

    // Fetch product reviews + site-wide aggregate in parallel
    const productUrl = `https://cache.judge.me/widgets/shopify/${shop}?product_id=${encodeURIComponent(productId)}&reviews_widget=1&page=1&json_request=1`;
    const aggregateUrl = `https://cache.judge.me/widgets/shopify/${shop}?all_reviews_rating=1&all_reviews_count=1&all_reviews_page=1&json_request=1`;

    Promise.all([
      fetch(productUrl).then(r => r.ok ? r.json() : null).catch(() => null),
      fetch(aggregateUrl).then(r => r.ok ? r.json() : null).catch(() => null),
    ]).then(([prod, agg]) => {
      const data = parseJudgeme(prod, agg);
      if (!data || (!data.reviews.length && !data.aggregate)) {
        renderJudgeme({ reviews: [], featured: null, aggregate: null });
        return;
      }
      try { sessionStorage.setItem(cacheKey, JSON.stringify(data)); } catch (_) {}
      renderJudgeme(data);
    });

    function parseJudgeme(prod, agg) {
      const out = { reviews: [], featured: null, aggregate: null };

      if (agg && (agg.all_reviews_rating || agg.all_reviews_count)) {
        out.aggregate = {
          rating: agg.all_reviews_rating ? parseFloat(agg.all_reviews_rating).toFixed(1) : null,
          count: agg.all_reviews_count ? String(agg.all_reviews_count).replace(/[^\d]/g, '') : null,
        };
      }

      // Aggregate from site-wide all-reviews response, Judge.me's cache returns
      // `html_miracle` (single string of HTML+style), not separate `header`/`html`.
      const aggHtml = (agg && (agg.all_reviews_header || agg.html_miracle || agg.header || agg.html || '')) + '';
      if (!out.aggregate && aggHtml) {
        const m = aggHtml.match(/data-average-rating['"]*\s*=\s*['"]([\d.]+)['"]/i)
              || aggHtml.match(/data-rating['"]*\s*=\s*['"]([\d.]+)['"]/i)
              || aggHtml.match(/jdgm-prev-badge__stars['"][^>]*data-score=['"](\d+)['"]/i);
        const c = aggHtml.match(/data-number-of-reviews['"]*\s*=\s*['"](\d+)['"]/i)
              || aggHtml.match(/jdgm-prev-badge__text['"][^>]*>\s*(\d{1,3}(?:,\d{3})*)\s*reviews?/i);
        if (m || c) {
          let rating = m ? parseFloat(m[1]) : null;
          if (rating !== null && rating > 5) rating = rating / 20; // 0-100 scale → 0-5
          out.aggregate = {
            rating: rating !== null ? rating.toFixed(1) : null,
            count: c ? c[1].replace(/[^\d]/g, '') : null,
          };
        }
      }

      appendReviews(agg && (agg.all_reviews || ''));
      if (!out.reviews.length) appendReviews(prod && (prod.all_reviews || prod.html_miracle || prod.widget || prod.html || ''));
      out.reviews = out.reviews.filter(r => r.score >= 4);

      // Pick the strongest 5★ as the featured pull quote, longest body wins
      const fives = out.reviews.filter(r => r.score === 5 && r.body.length > 60);
      out.featured = fives.sort((a, b) => b.body.length - a.body.length)[0] || out.reviews[0] || null;
      return out;

      function appendReviews(html) {
        if (!html || typeof DOMParser === 'undefined') return;
        const doc = new DOMParser().parseFromString(`<div>${html}</div>`, 'text/html');
        doc.querySelectorAll('.jdgm-rev').forEach(el => {
          const rating = el.querySelector('.jdgm-rev__rating');
          const timestamp = el.querySelector('.jdgm-rev__timestamp');
          const body = el.querySelector('.jdgm-rev__body p, .jdgm-rev__body');
          const bodyText = clean(body?.textContent || '');
          const usefulChars = bodyText.replace(/[^A-Za-z0-9]/g, '');
          if (!bodyText || usefulChars.length < 12) return;
          out.reviews.push({
            score: parseInt(rating && rating.dataset.score ? rating.dataset.score : '5', 10),
            author: clean(el.querySelector('.jdgm-rev__author')?.textContent || 'Verified buyer'),
            title: clean(el.querySelector('.jdgm-rev__title')?.textContent || ''),
            body: bodyText,
            time: formatReviewTime(timestamp?.dataset.content || timestamp?.textContent || ''),
          });
        });
      }
    }

    function clean(s) {
      return String(s || '')
        .replace(/<[^>]+>/g, ' ')
        .replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>')
        .replace(/&quot;/g, '"').replace(/&#39;|&apos;/g, "'")
        .replace(/\s+/g, ' ').trim();
    }

    function formatReviewTime(value) {
      const raw = clean(value);
      const t = Date.parse(raw);
      if (!Number.isFinite(t)) return raw;
      const days = Math.max(0, Math.round((Date.now() - t) / 86400000));
      if (days === 0) return 'Today';
      if (days === 1) return '1d';
      if (days < 60) return `${days}d`;
      return new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }).format(new Date(t));
    }

    function stars(n) {
      return '★★★★★'.slice(0, n) + '☆☆☆☆☆'.slice(0, 5 - n);
    }

    function renderJudgeme(data) {
      // Aggregate
      if (data.aggregate && ratingEl && data.aggregate.rating) {
        ratingEl.textContent = data.aggregate.rating;
      }
      if (data.aggregate && countEl && data.aggregate.count) {
        const n = parseInt(data.aggregate.count, 10);
        countEl.innerHTML = `· ${n.toLocaleString()}+ reviews`;
      }

      // Pull quote
      if (data.featured && pqBody && pqFoot) {
        const pullquote = pqBody.closest('[data-mk-judgeme-pullquote]');
        if (pullquote) pullquote.removeAttribute('hidden');
        pqBody.textContent = `"${data.featured.body}"`;
        const time = data.featured.time ? ` · ${data.featured.time}` : '';
        pqFoot.innerHTML = `<strong>${escapeHtml(data.featured.author)}</strong> · ${data.featured.score}★ · verified${escapeHtml(time)}`;
      }

      // Rail
      if (railEl && data.reviews.length) {
        const total = data.aggregate && data.aggregate.count ? parseInt(data.aggregate.count, 10) : data.reviews.length;
        let rendered = 0;

        const reviewTitle = (r) => {
          if (r.title) return r.title;
          const first = r.body.split(/[.!?]/)[0] || r.body;
          return first.length > 54 ? `${first.slice(0, 51).trim()}...` : first;
        };

        const reviewCard = (r) => {
          rendered += 1;
          const index = String(((rendered - 1) % Math.max(total, 1)) + 1).padStart(2, '0');
          const denominator = String(total).padStart(2, '0');
          return `
            <figure class="mk-pdp__review">
              <div class="mk-pdp__review-meta">
                <div class="mk-pdp__review-stars">${stars(r.score)}</div>
                <span class="mk-pdp__review-verified">Verified${r.time ? ` · ${escapeHtml(r.time)}` : ''}</span>
              </div>
              <div class="mk-pdp__review-title"><span aria-hidden="true">"</span>${escapeHtml(reviewTitle(r))}<span aria-hidden="true">"</span></div>
              <p class="mk-pdp__review-body">${escapeHtml(r.body)}</p>
              <figcaption class="mk-pdp__review-foot">&mdash; <strong>${escapeHtml(r.author)}</strong></figcaption>
            </figure>
          `;
        };

        const appendBatch = () => {
          railEl.insertAdjacentHTML('beforeend', data.reviews.map(reviewCard).join(''));
        };
        const scrollStep = () => {
          const card = railEl.querySelector('.mk-pdp__review');
          if (!card) return Math.max(railEl.clientWidth * 0.85, 320);
          const styles = window.getComputedStyle(railEl);
          const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
          return card.getBoundingClientRect().width + gap;
        };
        const scrollReviews = (direction) => {
          railEl.scrollTo({
            left: railEl.scrollLeft + (scrollStep() * direction),
            behavior: 'smooth',
          });
        };
        const updateControls = () => {
          if (prevBtn) prevBtn.disabled = railEl.scrollLeft <= 2;
          if (nextBtn) nextBtn.disabled = false;
        };
        const maybeAppend = () => {
          if (railEl.scrollLeft + railEl.clientWidth > railEl.scrollWidth - 900) {
            railEl._mkReviewAppend?.();
          }
          railEl._mkReviewUpdateControls?.();
        };
        railEl._mkReviewAppend = appendBatch;
        railEl._mkReviewUpdateControls = updateControls;
        railEl._mkScrollReviews = scrollReviews;

        railEl.classList.remove('is-loading');
        railEl.innerHTML = '';
        appendBatch();
        appendBatch();
        appendBatch();
        if (!railEl.dataset.mkInfiniteReviews) {
          railEl.dataset.mkInfiniteReviews = 'true';
          railEl.addEventListener('scroll', maybeAppend, { passive: true });
          if (prevBtn) prevBtn.addEventListener('click', () => railEl._mkScrollReviews?.(-1));
          if (nextBtn) nextBtn.addEventListener('click', () => railEl._mkScrollReviews?.(1));

          let dragging = false;
          let startX = 0;
          let startLeft = 0;
          railEl.addEventListener('pointerdown', (event) => {
            if (event.button !== 0) return;
            dragging = true;
            startX = event.clientX;
            startLeft = railEl.scrollLeft;
            railEl.classList.add('is-dragging');
            railEl.setPointerCapture?.(event.pointerId);
          });
          railEl.addEventListener('pointermove', (event) => {
            if (!dragging) return;
            railEl.scrollLeft = startLeft - (event.clientX - startX);
          });
          const stopDrag = (event) => {
            if (!dragging) return;
            dragging = false;
            railEl.classList.remove('is-dragging');
            railEl.releasePointerCapture?.(event.pointerId);
          };
          railEl.addEventListener('pointerup', stopDrag);
          railEl.addEventListener('pointercancel', stopDrag);
          railEl.addEventListener('mouseleave', () => {
            dragging = false;
            railEl.classList.remove('is-dragging');
          });
        }
        updateControls();
      } else if (railEl) {
        railEl.classList.remove('is-loading');
        railEl.innerHTML = '<div class="mk-pdp__reviews-empty">Verified Judge.me reviews are not available for this product yet.</div>';
      }
    }
  }

  function bindJudgemeSiteAggregate() {
    $$('[data-mk-judgeme-site]').forEach(root => {
      const shop = root.dataset.mkJudgemeShop;
      if (!shop) return;
      const ratingEl = root.querySelector('[data-mk-judgeme-site-rating]');
      const countEl = root.querySelector('[data-mk-judgeme-site-count]');
      const cacheKey = 'mk_jdgm_site_aggregate';

      const render = (data) => {
        if (!data) return;
        if (ratingEl && data.rating) ratingEl.textContent = data.rating;
        if (countEl && data.count) {
          const n = parseInt(data.count, 10);
          if (n) countEl.textContent = `${n.toLocaleString()}+ reviews`;
        }
      };

      try { render(JSON.parse(sessionStorage.getItem(cacheKey) || 'null')); } catch (_) {}

      const url = `https://cache.judge.me/widgets/shopify/${shop}?all_reviews_rating=1&all_reviews_count=1&all_reviews_page=1&json_request=1`;
      fetch(url)
        .then(r => r.ok ? r.json() : null)
        .then(agg => {
          const html = (agg && (agg.html_miracle || agg.header || agg.html || '')) + '';
          if (!html) return;
          const m = html.match(/data-average-rating['"]*\s*=\s*['"]([\d.]+)['"]/i)
            || html.match(/data-rating['"]*\s*=\s*['"]([\d.]+)['"]/i)
            || html.match(/jdgm-prev-badge__stars['"][^>]*data-score=['"](\d+)['"]/i);
          const c = html.match(/data-number-of-reviews['"]*\s*=\s*['"](\d+)['"]/i)
            || html.match(/jdgm-prev-badge__text['"][^>]*>\s*(\d{1,3}(?:,\d{3})*)\s*reviews?/i);
          if (!m && !c) return;
          let rating = m ? parseFloat(m[1]) : null;
          if (rating !== null && rating > 5) rating = rating / 20;
          const data = {
            rating: rating !== null ? rating.toFixed(1) : null,
            count: c ? c[1].replace(/[^\d]/g, '') : null,
          };
          try { sessionStorage.setItem(cacheKey, JSON.stringify(data)); } catch (_) {}
          render(data);
        })
        .catch(() => {});
    });
  }

  function formatStockCounts() {
    $$('[data-mk-stock-count]').forEach(el => {
      const n = parseInt(String(el.textContent || '').replace(/[^\d]/g, ''), 10);
      if (n) el.textContent = n.toLocaleString();
    });
  }

  // ── Product-grid pagination — bounded auto-load on scroll ──────────
  // The "Show more candles" button is hidden during each automatic run: the
  // next page fetches as the shopper nears the pager. The <a href> STAYS in
  // the DOM for crawlers, no-JS shoppers and the fetch-failure fallback — and
  // returns visibly when the bounded run ends.
  //
  // AUTO_LOAD_LIMIT bounds a run of consecutive auto-loads. Pure infinite
  // scroll makes the footer unreachable on a big collection (the anniversary
  // hub is ~647 products = 27 pages at 24/page), so after this many auto
  // pages the class comes off, the button returns, and the shopper chooses to
  // go on. A click resets the counter, so clicking buys another run.
  //
  // Only pagers carrying `data-mk-autoload` are observed. Both collection and
  // search grids opt in; Algolia search keeps its own fetch handler and the
  // observer dispatches to it via data-mk-alg-more.
  // 2026-09-04 (Ed): three automatic pages everywhere, then the button
  // returns. The stopping point keeps the footer and its popular-category
  // routes reachable instead of trapping a shopper in thousands of candles.
  // Clicking the button starts another three-page run. /collections/all's
  // private ?audit=1 catalogue view remains explicitly unbounded below.
  const AUTO_LOAD_LIMIT = 3;
  let autoLoadCount = 0;
  let pageLoading = false;
  let pagerObserver = null;

  function paintPagerStatus(pager) {
    let el = pager.querySelector('.mk-pagination__status');
    if (!el) {
      el = document.createElement('p');
      el.className = 'mk-pagination__status';
      // aria-live sits on the text only: the count changing after an append
      // ("48 of 647 shown") IS the announcement that more products arrived.
      el.innerHTML = '<span class="mk-pagination__spinner" aria-hidden="true"></span>' +
        '<span class="mk-pagination__status-text" aria-live="polite"></span>';
      pager.appendChild(el);
    }
    const small = pager.querySelector('[data-mk-next-page] small, [data-mk-alg-more] small');
    const text = el.querySelector('.mk-pagination__status-text');
    if (small && text) text.textContent = (small.textContent || '').trim();
    return el;
  }

  // A pager may override the bound with data-mk-autoload-max; 0 means "no
  // bound". Only /collections/all?audit=1 uses it — that page is Ed's
  // catalogue-review tool, never a shopper surface (it bounces home without
  // the param), so there is no footer to protect and stopping every 96
  // products would defeat the point of it.
  function pagerLimit(pager) {
    const raw = pager && pager.getAttribute('data-mk-autoload-max');
    if (raw === null || raw === '') return AUTO_LOAD_LIMIT;
    const n = parseInt(raw, 10);
    if (!isFinite(n) || n < 0) return AUTO_LOAD_LIMIT;
    return n === 0 ? Infinity : n;
  }

  // Re-arm after every append: the pager element is REPLACED by the next
  // page's pager, so a stale observer target would silently stop firing.
  function observePager(pager) {
    if (!pagerObserver || !pager) return;
    if (autoLoadCount >= pagerLimit(pager)) {
      pager.classList.remove('is-auto');
      return;
    }
    pager.classList.add('is-auto');
    paintPagerStatus(pager);
    pagerObserver.observe(pager);
  }

  async function loadNextPage(link, auto) {
    if (pageLoading) return;

    const root = link.closest('[data-mk-paginated]');
    const list = root && root.querySelector('[data-mk-list]');
    const pager = root && root.querySelector('[data-mk-pagination]');
    if (!root || !list || !pager) {
      window.location.href = link.href;
      return;
    }

    pageLoading = true;
    if (pagerObserver) pagerObserver.unobserve(pager);
    link.classList.add('is-loading');
    const status = pager.querySelector('.mk-pagination__status');
    if (status) status.classList.add('is-loading');
    const label = link.querySelector('span');
    const originalLabel = label ? label.textContent : '';
    if (label) label.textContent = 'Loading...';

    try {
      const res = await fetch(link.href, { credentials: 'same-origin' });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const nextRoot = doc.querySelector('[data-mk-paginated]');
      const nextList = nextRoot && nextRoot.querySelector('[data-mk-list]');
      const nextPager = nextRoot && nextRoot.querySelector('[data-mk-pagination]');
      if (!nextList) throw new Error('Missing product list');

      Array.from(nextList.children).forEach(card => list.appendChild(card));
      autoLoadCount = auto ? autoLoadCount + 1 : 0;
      if (nextPager) {
        pager.replaceWith(nextPager);
        observePager(nextPager);
      } else {
        if (pagerObserver) pagerObserver.disconnect();
        pager.remove();
      }
      // Appended cards are inert until repainted: hearts carry saved state,
      // quick-adds carry the in-cart tick.
      bindHearts();
      paintQuickAdds();
    } catch (_) {
      if (label) label.textContent = originalLabel || 'Show more candles';
      link.classList.remove('is-loading');
      if (status) status.classList.remove('is-loading');
      window.location.href = link.href;
    } finally {
      pageLoading = false;
    }
  }

  function bindLoadMore() {
    document.addEventListener('click', (e) => {
      const link = e.target.closest('[data-mk-next-page]');
      if (!link) return;
      e.preventDefault();
      loadNextPage(link, false);
    });

    if (!('IntersectionObserver' in window)) return;
    pagerObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        if (!el.classList.contains('is-auto')) return;
        const algLink = el.querySelector('[data-mk-alg-more]');
        if (algLink) {
          pagerObserver.unobserve(el);
          algLink.setAttribute('data-mk-auto-load', '');
          algLink.click();
          return;
        }
        const link = el.querySelector('[data-mk-next-page]');
        if (!link) { pagerObserver.unobserve(el); return; }
        loadNextPage(link, true);
      });
    }, { rootMargin: '200px 0px' });
    const pager = document.querySelector('[data-mk-pagination][data-mk-autoload]');
    if (pager) observePager(pager);
  }

  // ── Anniversary hub — the year Finder ──────────────────────────────
  // Ported verbatim from Ed's approved Claude Design file
  // (research/anniversary-hub/design/makester-anniversary-hub.html), logic
  // unchanged, just wrapped as a named bind function in the theme's IIFE
  // instead of the design's own standalone <script>. The relationship
  // between a wedding year and an anniversary number moves on every
  // 1 January, and Shopify's full-page cache can serve a render from before
  // that boundary, so build() and render() both read `new Date().getFullYear()`
  // live rather than trusting anything server-rendered (build-spec.md §5).
  function bindAnniversaryFinder() {
    const sel = document.getElementById('finder-year');
    const slot = document.getElementById('finder-slot');
    const card = document.getElementById('finder-card');
    if (!sel || !slot || !card) return;

    const MAT = {
      1: 'Paper', 2: 'Cotton', 3: 'Leather', 4: 'Fruit & Flowers / Linen', 5: 'Wood',
      6: 'Sugar / Iron', 7: 'Copper / Wool',
      8: 'Bronze', 9: 'Willow / Pottery', 10: 'Tin / Aluminium', 11: 'Steel', 12: 'Silk', 13: 'Lace',
      14: 'Ivory-coloured',
      15: 'Crystal', 16: 'Wax', 18: 'Porcelain', 20: 'China', 25: 'Silver', 30: 'Pearl', 35: 'Coral',
      40: 'Ruby', 45: 'Sapphire', 50: 'Gold', 55: 'Emerald', 60: 'Diamond', 65: 'Blue Sapphire',
      70: 'Platinum',
    };

    // Published year collections as of 2026-07-30: 1st to 51st continuously,
    // then 54th, 55th, 56th, 59th, 60th, 65th, 70th. The rest were deleted, so
    // any year outside this set sends the shopper to the all-anniversary rollup
    // instead of a 301 or a 404.
    const YEAR_PAGES = new Set([54, 55, 56, 59, 60, 65, 70]);
    for (let i = 1; i <= 51; i++) YEAR_PAGES.add(i);

    function ordinal(n) {
      const t = n % 100;
      if (t >= 11 && t <= 13) return n + 'th';
      const u = n % 10;
      return n + (u === 1 ? 'st' : u === 2 ? 'nd' : u === 3 ? 'rd' : 'th');
    }
    function currentYear() { return new Date().getFullYear(); }

    // Overwrites the Liquid-rendered (possibly cache-stale) option list, the
    // client-side pass is what guarantees correctness across a year boundary.
    function build() {
      const y = currentYear();
      const frag = document.createDocumentFragment();
      const ph = document.createElement('option');
      ph.value = ''; ph.textContent = 'Choose a year…'; ph.disabled = true; ph.selected = true;
      frag.appendChild(ph);
      for (let i = y; i >= y - 70; i--) {
        const o = document.createElement('option');
        o.value = String(i); o.textContent = String(i);
        frag.appendChild(o);
      }
      const e = document.createElement('option');
      e.value = 'earlier'; e.textContent = 'Earlier';
      frag.appendChild(e);
      sel.innerHTML = '';
      sel.appendChild(frag);
    }

    function render() {
      const v = sel.value;
      if (!v) { slot.classList.remove('is-open'); return; }
      const y = currentYear();
      let html = '';
      if (v === 'earlier') {
        html = '<h2>That’s 70+ years of marriage</h2><p class="finder__gift">Traditional gift: <strong>Platinum</strong> (70th)</p><a class="finder__cta" href="/collections/70th-anniversary-gifts">Shop 70th anniversary candles <span class="arrow">→</span></a>';
      } else {
        const n = y - parseInt(v, 10);
        if (n === 0) {
          html = '<h2>Getting married this year?</h2><p class="finder__gift">Congratulations from all of us</p><a class="finder__cta" href="/collections/wedding-gifts">Shop wedding candles <span class="arrow">→</span></a>';
        } else {
          const m = MAT[n];
          const giftLine = m ? (`Traditional gift: <strong>${m}</strong>`) : 'No traditional gift for this year. A candle that names it always works.';
          const cta = YEAR_PAGES.has(n)
            ? `<a class="finder__cta" href="/collections/${ordinal(n)}-anniversary-gifts">Shop ${ordinal(n)} anniversary candles <span class="arrow">→</span></a>`
            : '<a class="finder__cta" href="/collections/anniversary-gifts">Shop all anniversary candles <span class="arrow">→</span></a>';
          html = `<h2>That’s their ${ordinal(n)} anniversary</h2><p class="finder__gift">${giftLine}</p>${cta}`;
        }
      }
      card.innerHTML = html;
      slot.classList.add('is-open');
    }

    build();
    sel.addEventListener('change', render);
  }

  // ── Anniversary year/recipient pages — the live "Married in X?" line ──
  // Same freshness rule as the Finder: the Liquid fallback can be cache-stale,
  // so JS recomputes the married year from the live clock on every load.
  function bindAnniversaryLiveYear() {
    $$('[data-mk-anniv-live]').forEach(el => {
      const n = parseInt(el.dataset.mkAnnivLive || '0', 10);
      if (!n) return;
      const yearEl = $('[data-mk-anniv-live-year]', el);
      if (!yearEl) return;
      yearEl.textContent = String(new Date().getFullYear() - n);
    });
  }

  // Share. navigator.share exists on mobile Safari/Chrome and hands off to the
  // OS sheet (one tap to WhatsApp); desktop has no such API, so it copies and
  // says so. A dismissed share sheet rejects — that is a user choice, not an
  // error, so it stays silent and the icon never changes.
  function bindShare() {
    $$('[data-mk-share]').forEach(btn => {
      btn.addEventListener('click', async () => {
        const url = btn.dataset.mkShareUrl || location.href;
        const title = btn.dataset.mkShareTitle || document.title;
        if (navigator.share) {
          try { await navigator.share({ title, url }); } catch { /* dismissed */ }
          return;
        }
        try {
          await navigator.clipboard.writeText(url);
          announceCopied(btn, 'Link copied');
        } catch {
          window.prompt('Copy this link', url);
        }
      });
    });
  }

  function announceCopied(btn, message) {
    const live = $('[data-mk-share-live]');
    if (live) live.textContent = message;
    btn.classList.add('is-copied');
    clearTimeout(btn._mkCopiedTimer);
    btn._mkCopiedTimer = setTimeout(() => {
      btn.classList.remove('is-copied');
      if (live) live.textContent = '';
    }, 1800);
  }

  // ── Bootstrap ─────────────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', () => {
    bindShare();
    bindHearts();
    bindGalleries();
    bindMegaNavPositioning();
    paintRecent();
    paintClubSaved();
    bindTypeSearch();
    bindReviewPeel();
    bindReviewList();
    bindCollectionsDrift();
    bindJudgeme();
    bindJudgemeSiteAggregate();
    formatStockCounts();
    bindLoadMore();
    bindAlgSearch();
    bindCartPage();
    bindAnniversaryFinder();
    bindAnniversaryLiveYear();
    MK.refreshCart().then(() => { paintBagCount(); });
    // Search boxes get NO dropdown (Ed, 2026-08-31) — see the removal note
    // above wireSuggest's old home. Every box is now a plain form: type,
    // press Search, land on the results page.
    focusEmptySearch();
  });

  // ── Empty search page: put the cursor in the box ───────────────────
  // The header's magnifier is a plain link to /search on mobile (Ed, 20 Jul),
  // so a shopper who taps it arrives at the "What are you looking for?" page
  // and has to find and tap the box before she can type. Measured on a real
  // buyer 2026-08-30 (Clarity `mttg2v`, from the Luxury Candle page).
  // Focusing on arrival removes the hunt. NOTE: iOS Safari and Android Chrome
  // both refuse to raise the on-screen keyboard for a focus that no gesture
  // asked for, so this saves the hunting, not necessarily the second tap.
  function focusEmptySearch() {
    if (location.pathname !== '/search') return;
    if ((new URLSearchParams(location.search).get('q') || '').trim()) return;
    const box = $('.mk-csearch__input') || $('.mk-search__input');
    if (box) try { box.focus({ preventScroll: true }); } catch (_) { box.focus(); }
  }

  // ── Utilities ────────────────────────────────────────────────────
  function escapeHtml(s) {
    return String(s ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  }
})();
